module.exports = __webpack_public_path__ + "static/media/5.04520b31.png";